// import React, { useEffect, useState, useRef } from 'react';
// import { apiGET } from '../../utilities/apiHelpers';
// import { useNavigate } from 'react-router-dom';
// import Slider from "react-slick";
// import Rectangle from '../../assest/image/Rectangle.svg';
// import left_arrow from '../../assest/image/left_arrow.svg';
// import right_arrow from '../../assest/image/right_arrow.svg';

// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const Banner = () => {
//   const [bannerImages, setBannerImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const sliderRef = useRef(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchBannerImages = async () => {
//       try {
//         const response = await apiGET('v1/bannerImg/get-all-banner-img');
//         const data = response.data?.data?.data || response.data?.data || [];
//         setBannerImages(data);
//       } catch (err) {
//         console.error("Banner API Error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchBannerImages();
//   }, []);

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 5000, // Reduced from 20000 for better UX
//     arrows: false,
//   };

//   const handleShopNow = (e) => {
//     e.stopPropagation(); 
//     navigate('/products');
//   };

//   if (loading) return <div className="p-10 text-center font-bold text-[#14967F]">Loading...</div>;

//   return (
//     <div className="w-full mt-4 md:mt-8 px-2 md:px-4">
//       <div className="relative group">
        
//         {/* Navigation Arrows - Hidden on small mobile, visible on hover/tablet */}
//         <button 
//           onClick={() => sliderRef.current.slickPrev()}
//           className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 z-20 transition-all opacity-0 group-hover:opacity-100 active:scale-90 hidden sm:block"
//         >
//           <img 
//             src={left_arrow} 
//             alt="prev" 
//             className="w-8 h-8 md:w-12 md:h-12" 
//             style={{ filter: "invert(46%) sepia(59%) saturate(452%) hue-rotate(124deg) brightness(91%) contrast(88%)" }} 
//           />
//         </button>

//         <button 
//           onClick={() => sliderRef.current.slickNext()}
//           className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 z-20 transition-all opacity-0 group-hover:opacity-100 active:scale-90 hidden sm:block"
//         >
//           <img 
//             src={right_arrow} 
//             alt="next" 
//             className="w-8 h-8 md:w-12 md:h-12"
//             style={{ filter: "invert(46%) sepia(59%) saturate(452%) hue-rotate(124deg) brightness(91%) contrast(88%)" }}
//           />
//         </button>

//         {bannerImages.length > 0 ? (
//           <Slider ref={sliderRef} {...settings}>
//             {bannerImages.map((image, index) => (
//               <div 
//                 key={image._id || index} 
//                 className="outline-none"
//                 // onClick={() => navigate('/products')}
//               >
//                 {/* Responsive Container: 
//                    - aspect-[16/9] for mobile (Proportional)
//                    - h-auto for mobile to prevent cropping
//                    - md:h-[400px] for desktop 
//                 */}
//                 <div className="relative w-full aspect-[16/8] sm:aspect-auto sm:h-[300px] md:h-[450px] rounded-[16px] overflow-hidden border-[2px] md:border-[3px] border-[#14967F] cursor-pointer mx-auto">
//                   <img
//                     src={image.bannerImgUrl || Rectangle}
//                     alt="banner"
//                     className="w-full h-full object-cover sm:object-fill lg:object-cover"
//                   />
                  
//                   {/* Text Overlay: Uses different padding and alignment for mobile */}
//                   <div className="absolute inset-0 p-6 md:p-16 flex flex-col justify-center bg-gradient-to-r from-white/60 via-white/20 to-transparent">
//                     <h1 className="text-gray-900 text-xl sm:text-3xl md:text-5xl font-bold max-w-[200px] sm:max-w-lg leading-tight mb-3 md:mb-6">
//                       {image.title || "BANNER TITLE"}
//                     </h1>
                    
//                     <button 
//                       onClick={handleShopNow}
//                       className="w-fit bg-[#14967F] text-white font-semibold py-2 px-6 md:py-3 md:px-10 rounded-lg md:rounded-xl text-xs md:text-lg hover:shadow-lg transition-all"
//                     >
//                       Shop Now
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </Slider>
//         ) : null}
//       </div>
//     </div>
//   );
// };

// export default Banner; 

import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";

// Utilities
import { apiGET } from '../../utilities/apiHelpers';

// Assets (Ensure these paths are correct in your project)
import Rectangle from '../../assest/image/Rectangle.svg';
import left_arrow from '../../assest/image/left_arrow.svg';
import right_arrow from '../../assest/image/right_arrow.svg';

// Slick Carousel CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Banner = () => {
  const [bannerImages, setBannerImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const sliderRef = useRef(null);
  const navigate = useNavigate();

  // 1. Fetch Banner Data
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await apiGET('v1/bannerImg/get-all-banner-img');
        
        /* Based on your JSON structure: 
           Axios (response) -> API Wrapper (data) -> Result Object (data) -> Array (data)
        */
        const actualData = response.data?.data?.data || [];
        setBannerImages(actualData);
        
        console.log("Banners Loaded successfully:", actualData.length);
      } catch (err) {
        console.error("Banner API Error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBannerImages();
  }, []);

  // 2. Slider Settings
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  };

  if (loading) {
    return (
      <div className="p-10 text-center font-bold text-[#14967F] animate-pulse">
        Loading Banners...
      </div>
    );
  }

  return (
    <div className="w-full mt-4 md:mt-8 px-2 md:px-4">
      <div className="relative group">
        
        {/* Custom Navigation Arrows */}
        {bannerImages.length > 1 && (
          <>
            <button 
              onClick={() => sliderRef.current.slickPrev()}
              className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 z-20 transition-all opacity-0 group-hover:opacity-100 active:scale-90 hidden sm:block"
            >
              <img 
                src={left_arrow} 
                alt="prev" 
                className="w-8 h-8 md:w-12 md:h-12" 
                style={{ filter: "invert(46%) sepia(59%) saturate(452%) hue-rotate(124deg) brightness(91%) contrast(88%)" }} 
              />
            </button>

            <button 
              onClick={() => sliderRef.current.slickNext()}
              className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 z-20 transition-all opacity-0 group-hover:opacity-100 active:scale-90 hidden sm:block"
            >
              <img 
                src={right_arrow} 
                alt="next" 
                className="w-8 h-8 md:w-12 md:h-12"
                style={{ filter: "invert(46%) sepia(59%) saturate(452%) hue-rotate(124deg) brightness(91%) contrast(88%)" }}
              />
            </button>
          </>
        )}

        {/* Main Slider Section */}
        {bannerImages.length > 0 ? (
          <Slider ref={sliderRef} {...settings}>
            {bannerImages.map((image) => (
              <div key={image._id} className="outline-none">
                <div className="relative w-full aspect-[16/8] sm:aspect-auto sm:h-[300px] md:h-[450px] rounded-[16px] overflow-hidden border-[2px] md:border-[3px] border-[#14967F] cursor-pointer mx-auto">
                  
                  {/* Banner Image */}
                  <img
                    src={image.bannerImgUrl || Rectangle}
                    alt={image.title}
                    className="w-full h-full object-cover sm:object-fill lg:object-cover"
                  />
                  
                  {/* Text and Button Overlay */}
                  <div className="absolute inset-0 p-6 md:p-16 flex flex-col justify-center bg-gradient-to-r from-white/70 via-white/20 to-transparent">
                    <h1 className="text-gray-900 text-xl sm:text-3xl md:text-5xl font-bold max-w-[200px] sm:max-w-lg leading-tight mb-3 md:mb-6 uppercase">
                      {image.title || "Special Offer"}
                    </h1>
                    
                    {/* ✅ CONDITIONAL RENDERING: Only show if productId exists */}
                    {image.productId ? (
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/product/${image.productId}`);
                        }}
                        className="w-fit bg-[#14967F] text-white font-semibold py-2 px-6 md:py-3 md:px-10 rounded-lg md:rounded-xl text-xs md:text-lg hover:bg-[#0d6e5d] hover:shadow-xl transition-all active:scale-95 shadow-md"
                      >
                        Shop Now
                      </button>
                    ) : (
                      /* Optional: Placeholder text or empty space if no link exists */
                      <span className="text-[#14967F] font-bold text-xs md:text-sm tracking-widest opacity-70">
                      
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="h-40 flex items-center justify-center text-gray-400 bg-gray-50 rounded-xl border-2 border-dashed">
            No banners to display
          </div>
        )}
      </div>
    </div>
  );
};

export default Banner;